// /explore with the 100% Commission chip on (ID-118): which inline state replaces the list. Pure.
import type { LocationQueryValue } from 'vue-router';

export type ExclusiveExploreGate = 'sign_in' | 'emirates_id' | null;

type FetchErrorLike = { statusCode?: number; status?: number; data?: { data?: { reason?: string } } };

export const exclusiveGateFor = (error: unknown): ExclusiveExploreGate => {
  if (!error || typeof error !== 'object') return null;
  const e = error as FetchErrorLike;
  const status = e.statusCode ?? e.status;
  if (status === 401) return 'sign_in';
  if (status === 403 && e.data?.data?.reason === 'emirates_id_required') return 'emirates_id';
  return null;
};

export const isExclusiveQueryOn = (raw: LocationQueryValue | LocationQueryValue[] | undefined): boolean => {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value === '1' || value === 'true';
};

// URL form of the chip: exclusive=1 when on, absent when off.
export const withExclusiveUrlParam = <T extends Record<string, unknown>>(query: T): Record<string, unknown> => {
  const { exclusive, ...rest } = query;
  return exclusive === true || exclusive === 'true' || exclusive === '1' || exclusive === 1
    ? { ...rest, exclusive: '1' }
    : rest;
};

// The chip is always in the brand gold so it stands out from the neutral chips: light gold idle, solid gold on.
// `info` styles the attached "i" button so chip + "i" read as one control.
export const exclusiveChipClasses = (active: boolean): { chip: string; icon: string; info: string } =>
  active
    ? {
        chip: 'border-gold-primary-120 bg-gold-primary-100 text-black-100 hover:bg-gold-primary-120',
        icon: 'text-black-100',
        info: 'border-gold-primary-120 bg-gold-primary-100 text-black-100 hover:bg-gold-primary-120',
      }
    : {
        chip: 'border-gold-primary-100 bg-gold-primary-20 text-black-100 hover:bg-gold-primary-30',
        icon: 'text-gold-primary-120',
        info: 'border-gold-primary-100 bg-gold-primary-20 text-gold-primary-120 hover:bg-gold-primary-30',
      };
